import LoadingButton from '@mui/lab/LoadingButton'
import { CircularProgress, useTheme } from '@mui/material'

const LoadingButtonUi = props => {
  const theme = useTheme()

  return (
    <LoadingButton
      {...props}
      variant={props.variant || 'contained'}
      fullWidth
      loadingIndicator={
        <CircularProgress
          sx={{
            color: theme.palette.grey[100]
          }}
          size={30}
        />
      }
      sx={{
        ...props.sx,
        width: '100%',
        minHeight: '32px',
        height: props.height || '48px',
        background: props.loading
          ? theme.palette.primary.main
          : props.disabled
            ? theme.palette.grey[200]
            : theme.palette.primary.main,
        fontSize: '14px',
        height: '44px',
        fontWeight: 500,
        borderRadius: '8px',
        '&.Mui-disabled': {
          background: props.loading ? theme.palette.primary.main : theme.palette.grey[200]
        }
      }}
    />
  )
}

export default LoadingButtonUi
